import styled, { css } from "styled-components";
import theme from "../../constants/globalStyles/theme.json";

const { spacing, radius, breakpoints } = theme;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.primary.offWhite};
  padding-right: ${spacing.space32};
  border-radius: ${radius.large};
  scroll-margin-top: 25px;

  @media (max-width: ${breakpoints.s}) {
    padding-right: 0;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  min-width: 400px;

  @media (max-width: ${breakpoints.m}) {
    min-width: 50px;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Input = styled.input<{ $error?: boolean }>`
  margin-bottom: ${spacing.space16};
  padding: ${spacing.space16};
  border: 1px solid #ccc;
  border-radius: ${radius.small};
  font-size: 1rem;
  font-family: "Open Sans", sans-serif;
  width: 70%;

  &:focus {
    border-color: #666;
    outline: none;
  }

  ${(props) =>
    props.$error &&
    css`
      border-color: red;
      background-color: #ffe6e6;
    `}

  @media (max-width: ${breakpoints.m}) {
    width: 85%;
  }
`;

export const PostalInput = styled.input<{ $error?: boolean }>`
  margin-bottom: ${spacing.space16};
  padding: ${spacing.space16};
  border: 1px solid #ccc;
  border-radius: ${radius.small};
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  max-width: 40%;

  &:focus {
    border-color: #666;
    outline: none;
  }

  ${(props) =>
    props.$error &&
    css`
      border-color: red;
      background-color: #ffe6e6;
    `}

  @media (max-width: ${breakpoints.m}) {
    max-width: 40%;
  }
`;

export const PostalOutput = styled.input`
  margin-bottom: ${spacing.space16};
  padding: ${spacing.space16};
  border: 1px solid #ccc;
  border-radius: ${radius.small};
  font-size: 1rem;
  font-family: "Open Sans", sans-serif;
  width: 55%;
  background-color: rgb(236, 236, 233);

  @media (max-width: ${breakpoints.m}) {
    max-width: 45%;
  }
`;

export const PostalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.space16};
  margin-bottom: ${spacing.space16};

  @media (max-width: ${breakpoints.s}) {
    flex-direction: column;
    gap: 0;
    margin-bottom: 0;
  }
`;

export const Label = styled.label`
  margin-bottom: ${spacing.space4};
  font-size: 0.875rem;
`;

export const TextArea = styled.textarea<{ $error?: boolean }>`
  margin-bottom: ${spacing.space16};
  padding: ${spacing.space12};
  border: 1px solid #ccc;
  border-radius: ${radius.small};
  font-size: 1rem;
  font-family: "Open Sans", sans-serif;
  width: 100%;
  height: 220px;
  resize: vertical;

  ${(props) =>
    props.$error &&
    css`
      border-color: red;
      background-color: #ffe6e6;
    `}

  @media (max-width: ${breakpoints.m}) {
    width: 89%;
  }
`;

export const ValidationContainer = styled.div`
  display: flex;
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 0.875rem;
  margin-top: -${spacing.space2};
  margin-left: ${spacing.space8};
`;

export const ConfirmationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
  justify-content: center;
`;

export const ConfirmationMessage = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;

  @media (max-width: ${breakpoints.s}) {
    color: ${theme.colors.primary.black};
  }
`;
